<ng-content></ng-content>



// WEBPACK FOOTER //
// ../../../../../src/material/card/card.html